// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ZmeY","footer":"ReportModalFilter_footer__1u55p"};